import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import dateFormat, { masks } from "dateformat";

@Injectable({
  providedIn: 'root'
})
export class GeneralServicesService {

  constructor() { }

  async modalMensaje({ titulo = '', mensaje = '', time = 5000 }) {
    Swal.close();
    Swal.fire({
      showConfirmButton: true,
      html:
        ' <i class="far fa-laugh" style="color:#000000;font-size: 58px;margin: 20px 40px 10px;"></i> <br>' +
        ' <h1 style="font-family: sans-serif !important;padding: 0 20px; font-style: normal;justify-content: center;font-size: 38px; line-height: 48px; display: flex; align-items: center; text-align: center; color: #000000;" > ' + titulo + '</h1>' +
        ' <p style="font-family: sans-serif !important;padding: 0 20px; font-style: normal;justify-content: center; font-size: 20px; line-height: 25px; display: flex; align-items: center; text-align: center; color: #000000;" > ' + mensaje + '</p>',
      timer: time,
      customClass: {
        confirmButton: 'botonOk',
        // cancelButton: 'btn-swal-v2-cancel',
        // popup: 'container-swal-v2-customer'
      }
    })
  }

  async modalErrorMensaje(titulo,mensaje) {
    Swal.close();
    Swal.fire({
      html:
        ' <i class="fas fa-exclamation-circle" style="color:red;font-size: 58px;margin: 20px 40px 10px;"></i> <br>' +
        ' <h1 style="font-family: sans-serif !important; font-style: normal;justify-content: center; font-size: 38px; line-height: 48px; display: flex; align-items: center; text-align: center; color: #000000;" > ' + titulo + '</h1>' +
        ' <p style="font-family: sans-serif !important;padding: 0 20px; font-style: normal;justify-content: center; font-size: 20px; line-height: 25px; display: flex; align-items: center; text-align: center; color: #000000;" > ' + mensaje + '</p>',
      timer: 5000,
    })
  }

  async modalCargando() {
    Swal.close();
    Swal.fire({
      icon: 'info',
      title: 'Espere por favor...',
      showConfirmButton: false,
      allowOutsideClick: false,
      timer: 1000000
    })
    Swal.showLoading();
  }

  fechaActualString() {
    let fecha = dateFormat(new Date(), 'dd/mm/yyyy - HH:MM');
    //console.log(fecha, 'fecha');
    return fecha;
  }
}
